// Б.2.d: Инициатор — пассивка onSpawn (TTL=2 хода).
//
// В ход выставления (или пробуждения, если в Режиме ожидания) и СЛЕДУЮЩИЙ ход
// у владельца Инициатора отменяются 2 правила Синтетикса:
//   1. Можно играть СКОЛЬКО УГОДНО Модификаций за ход (лимит «1 Мод» снят).
//   2. Модификации НЕ наносят урон Герою владельца, прогрессия НЕ тикает.
//
// Основная карта (Юнит/Действие) ВСЁ РАВНО обязательна — правило Ф2-fix2 не
// отменяется полностью (Мод требует основную). Отменяется только лимит «1 Мод
// за ход» и прогрессия урона.
//
// Состояние: player.activeInitiatorEffect = { remainingTurns: 2 }.
// На EOT (после ходов N и N+1) decrement; при 0 — сброс.
// Если Инициатор умирает до истечения — эффект сохраняется до запланированного
// срока (это легендарка, эффект «оплачен» выставлением).
//
// Прогрессия modPlaysCount при Инициаторе НЕ тикает — после окончания эффекта
// продолжается с того числа, на котором остановилась.
//
// Легендарка → Режим ожидания (4-й ход). Эффект стартует в момент пробуждения.

export const CARD_ID = 'syn_initsiator';

export function initsiatorOnSpawn(state, ownerIdx, card) {
  if (!card || card.id !== CARD_ID) return;
  if (!card.isAlive()) return;
  const p = state.players[ownerIdx];
  // Активируем эффект: 2 хода (этот + следующий).
  p.activeInitiatorEffect = { remainingTurns: 2 };
  state.log.add(
    `🚀 ${card.name_ru} [${p.name}]: эффект активен 2 хода — много Модов без урона Герою`
  );
}

// Вызывается на EOT (после Ф5) для каждой стороны. Декремент TTL.
export function initsiatorOnEndOfTurn(state, ownerIdx) {
  const p = state.players[ownerIdx];
  if (!p.activeInitiatorEffect) return;
  p.activeInitiatorEffect.remainingTurns -= 1;
  if (p.activeInitiatorEffect.remainingTurns <= 0) {
    p.activeInitiatorEffect = null;
    state.log.add(`🚀 Инициатор [${p.name}]: эффект истёк, обычные правила Модов вернулись`);
  }
}

// Хелпер: активен ли эффект Инициатора у игрока.
export function isInitiatorActive(player) {
  return !!(player.activeInitiatorEffect && player.activeInitiatorEffect.remainingTurns > 0);
}
